/* eslint-disable no-unused-vars */
import axios from 'axios';
import { authorizeToken, localLoginToken } from '../../authorization/login';
// eslint-disable-next-line import/prefer-default-export
export async function postData(url, payload, isAuth = true) {
    let res;
    try {
        if (isAuth) {
            res = await axios.post(url, payload, {
                headers: {
                    Authorization: `Basic ${localLoginToken}`,
                },
            });
        }

        return res;
    } catch (error) {
        return error;
    }
}
